'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlModuleOfComparoscope", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: "<span tl-tooltip=\"Observatoire financier - Comparoscope\" class=\"mr-s module-ofs\">OFC</span>"
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/modules/tl-module-of-comparoscope.js
// module id = 2859
// module chunks = 13